function Footer(props) {
    return (
        <footer style={{ width: '100%', padding: '1em', display: 'flex', gap: '.6em', fontSize: '0.8em', alignItems: "center" }}>
            {/* <Box sx={{ display: "flex", alignItems: "center", gap: '.6em' }}>
                {props.StatusMessage[0] || ''}
            </Box>
            {props.StatusMessage[2] ? <LinearProgress variant="determinate" value={props.StatusMessage[1] / (props.StatusMessage[2] - 1) * 100} sx={{ flexGrow: 1 }} /> : ''}
            <Box sx={{ flexGrow: 1 }} />
            <a href="https://codific.ar/" target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'none', color: 'inherit' }}>
                © Codific.ar 2026
            </a> */}
        </footer>
    );
}

export default Footer;
